import moment from 'moment-timezone';
moment.tz.setDefault("Asia/Bangkok");
moment.locale('th')

export default moment
